import { Link } from "react-router-dom";

export default function HeroSection() {
    return (
        <section className="pt-6 md:pt-14 pb-2">
            <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
                {/* Text Content */}
                <div className="ms-4">
                    <h3 className="text-indigo-900 text-[14.5px] md:text-base lg:text-lg font-semibold mb-1.5">
                        Integrated
                    </h3>
                    <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-blue-900 leading-tight w-[90%] lg:w-full">
                        IT Employee Transport Service
                    </h1>
                    <p className="text-gray-700 text-sm sm:text-base md:text-lg mt-3 mb-3 font-medium">
                        Empowering your workforce with solutions.
                        From commutes to shift travel, we ensure reliable mobility.
                    </p>

                    <Link to="/contact" className="bg-green-900 text-white px-2.5 py-1.5 md:px-4 text-sm sm:text-base md:py-2 rounded-sm shadow hover:bg-green-700 transition font-bold">
                        Contact Us
                    </Link>
                </div>

                {/* Video Content */}
                <div className="overflow-hidden flex justify-center items-center">

                    <img
                        width="100%"
                        src="/Gemini_Generated_Image_z4nq2jz4nq2jz4nq.png"

                        className="w-full lg:w-[85%] object-cover"
                    />
                    {/* <video
                        src="/hero_video.mp4"
                        className="w-full lg:w-[85%]"
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="metadata"
                    /> */}

                </div>

            </div>
        </section>
    );
}
